
{
  "fr": {
    "configuratorCrossSellModal": {
      "quantityLoading": "Chargement des quantités...",
      "addToCart": "Ajouter",
      "addingToCart": "En cours...",
      "addedToCart": "Ajouté",
      "keepBrowsing": "Continuer mes achats",
      "goToCart": "Aller au panier"
    }
  }
}
